module.exports = __webpack_public_path__ + "img/title.7b1a2b87.png";